import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import PerfectScrollbar from "perfect-scrollbar";
import { isMobile } from "react-device-detect";
import useWindowSize from "../../../../../../core/hooks/useWindowSize";
import VehicleListGridTableItem from "./VehicleListGridTableItem";
import * as globalVariables from "../../../../../../includes/variables";

function descendingComparator(a, b, orderBy) {

  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {

  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const StyledTableCell = withStyles(() => ({
  head: {
    backgroundColor: "#e9ecef",
    fontSize: 15,
    //fontWeight: "bolder",
    //color: theme.palette.common.white,
  },
}))(TableCell);



const useStyles = makeStyles(() => ({

  table: {
    minWidth: 500,
  },
  head: {
    backgroundColor: "#f4f4f4",
  },
  selected: {
    backgroundColor: "#ffddcc",
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  cellPaddingFirstStyle: {
    padding: "16px 1px 16px 10px",
    //backgroundColor : "#ffddcc"
  },
  cellPaddingStyle: {
    padding: "16px 0px 16px 0px",
    //backgroundColor : "#ffddcc"
  },
}));
const headCells = [
  {
    id: "Ignition",
    label: "TYPE",
    numeric: false,
    disablePadding: false,
    width: 80,
    minWidth: 80,
  },
  {
    id: "VehiclePlate",
    label: "Plate",
    numeric: false,
    disablePadding: false,
    width: 5,
    minWidth: 10,
  },
  {
    id: "VehicleCode",
    label: "Code",
    numeric: false,
    disablePadding: false,
    width: 5,
    minWidth: 10,
  },
  {
    id: "FleetName",
    label: "Fleet",
    numeric: false,
    disablePadding: false,
    width: 5,
    minWidth: 10,
  },

  {
    id: "OdometerReadingTimestamp",
    label: "Last",
    numeric: false,
    disablePadding: false,
    width: 5,
    minWidth: 10,
  },
  {
    id: "LocationDescription",
    label: "Location",
    numeric: false,
    disablePadding: false,
    width: 5,
    minWidth: 200,
  },
];

function EnhancedTableHead(props) {
  const { classes, order, orderBy, onRequestSort } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  const setHeaderLabel = (headerLabel) => {
    if (headerLabel === "Ignition")
      return (
        <img
          src={globalVariables.imgPath.ignitionOn}
          style={{ width: 25 }}
          alt="ignition"
        />
      );


    return headerLabel;
  };

  return (
    <TableHead className={classes.head}>
      <TableRow>
        {headCells.map((headCell) => (
          <StyledTableCell
            key={headCell.id}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "default"}
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ minWidth: headCell.minWidth }}
            className={
              headCell.label === "Status"
                ? classes.cellPaddingFirstStyle
                : classes.cellPaddingStyle
            }
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {setHeaderLabel(headCell.label)}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </StyledTableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  searchVehicleType: PropTypes.string.isRequired,
};

const VehicleListGridTable = (props) => {
  const { details, clickedVehicle, clickedLicence } = props;

  const classes = useStyles();

  const windowSize = useWindowSize();

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("StationName");
  const [selectedVehicle, setSelectedVehicle] = useState();

  useEffect(() => {
    try {
      const perfectScrollbar = new PerfectScrollbar(".perfect-scrollbar", {
        wheelSpeed: 0.2,
      });
      perfectScrollbar.update();
    } catch (_ex) {
      // ignore perfect-scrollbar init/update errors (e.g. when the container isn't laid out yet)
    }
  }, [details]);

  const handleRequestSort = (event, property) => {

    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const onClickVehicle = useCallback(
    (item) => {
      setSelectedVehicle(item);
      clickedVehicle(item);
    },
    [clickedVehicle]
  );

  const onClickLicence = useCallback(
    (item) => {
      clickedLicence(item);
    },
    [clickedLicence]
  );

  const getStyle = () => {
    //alert(windowSize.height);
    if (!isMobile) {
      return null;
    }

    return {
      height: windowSize.height - 116,
    };
  };

  const getTableContent = () => {
    if (details) {
      return (
        <TableBody>
          {stableSort(details, getComparator(order, orderBy)).map((row) => (
            <VehicleListGridTableItem
              key={row.VehicleId}
              item={row}
              clickedVehicle={onClickVehicle}
              clickedLicence={onClickLicence}
              selected={selectedVehicle && row.VehicleId === selectedVehicle.VehicleId}
            />
          ))}
        </TableBody>
      );
    }
  };


  return (
    <Paper className={classes.paper}>
      <TableContainer
        className="table-responsive summry-table d-xs-block summary-vehicles main-content-fullheight"
        style={getStyle()}
      >
        <div
          className="perfect-scrollbar"
          style={{ position: "relative", width: "100%", height: "100%" }}
        >
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            size="small"
            //aria-label="enhanced table"
            stickyHeader
            aria-label="sticky a dense table"
          >
            <EnhancedTableHead
              classes={classes}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              searchVehicleType={""}
            />

            {getTableContent()}
          </Table>
        </div>
      </TableContainer>
    </Paper>
  );
};

export default VehicleListGridTable;
